import script from "./checkMaterial.vue?vue&type=script&setup=true&lang=js"
export * from "./checkMaterial.vue?vue&type=script&setup=true&lang=js"

import "./checkMaterial.vue?vue&type=style&index=0&id=508eff84&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508eff84"]])

export default __exports__